import { isFunction } from '../util';
import { makeCatalystFetchPostInit } from '../../../../CRA/src/Components/util/fetchUtility'
import $ from 'jquery';
import * as gtm from '../gtm';

const AddToCartConfirmationKey = "AddToCartConfirmation";

//Minicart
var $miniCart = function () {
    return $("div#miniCart");
};

var $addToCartConfirmation = function () {
    return $("div#addToCartConfirmation");
};

export const showMiniCart = function () {
    $("#mini-cart-dropdown-button").dropdown('show');
};

export const hideMiniCart = function () {
    $("#mini-cart-dropdown-button").dropdown('hide');
};

var addMiniCartClick = function () {
    $miniCart().find("a.product-remove").click(function () {
        var productCode = $(this).attr("data-code");
        fetch(removeFromCartUrl, makeCatalystFetchPostInit({ SKU: productCode }))
            .then(() => location.reload())
            .catch(() => location.reload());
    });
};

var updateMiniCart = function (onSuccess, itemsAddedToCart = 0) {
    var miniCartUrl = new URL($miniCart().data("url"), window.location.origin);
    miniCartUrl.searchParams.set("itemsAddedToCart", itemsAddedToCart)

    return $.ajax({
        type: "GET",
        url: miniCartUrl.toString(),
        cache: false,
        success: function (data) {
            $miniCart().replaceWith(data);
            addMiniCartClick();
            isFunction(onSuccess) && onSuccess();
        }
    });
};

var displayAddToCartConfirmation = function (codes) {
    showMiniCart();
    initiateMinicartAutoTimeout();
};

// After a user adds an item to cart
// Minicart will stay active for at least 7 seconds when unhovered
// Minicart will stay active indefinitely when hovered, with a hover exit delay of 300 - 500ms
let minicartAutoHideTimeoutStart;
let minicartAutoHideTimeout;
const initiateMinicartAutoTimeout = function () {
    setMinicartAutoTimeout(7000);
    minicartAutoHideTimeoutStart = new Date();
    $miniCart().on("mouseenter", pauseMinicartAutoTimeout);
    $miniCart().on("mouseleave", extendMinicartAutoTimeout);
    $(".minicart__dropdown-wrapper").on('hidden.bs.dropdown', cleanupMinicartAutoTimeout);
}
const setMinicartAutoTimeout = function (delay) {
    minicartAutoHideTimeout = setTimeout(() => {
        hideMiniCart();
        cleanupMinicartAutoTimeout();
    }, delay);

}
const pauseMinicartAutoTimeout = function () { clearTimeout(minicartAutoHideTimeout); }
const extendMinicartAutoTimeout = function () {
    clearTimeout(minicartAutoHideTimeout);
    let delay = Math.max(Math.max(0, 7000 - (new Date() - minicartAutoHideTimeoutStart)), (Math.random() * 200 + 300));
    setMinicartAutoTimeout(delay);
};
const cleanupMinicartAutoTimeout = function () {
    $miniCart().off("mouseenter", pauseMinicartAutoTimeout);
    $miniCart().off("mouseleave", extendMinicartAutoTimeout);
    $(".minicart__dropdown-wrapper").off('hidden.bs.dropdown', cleanupMinicartAutoTimeout);
    clearTimeout(minicartAutoHideTimeout);
    minicartAutoHideTimeout = null;
}

const saveAddToCartConfirmation = function (codes) {
    sessionStorage.setItem(AddToCartConfirmationKey, JSON.stringify(codes));
};

const displaySavedAddToCartConfirmation = () => {
    const codes = sessionStorage.getItem(AddToCartConfirmationKey);
    if (codes) {
        displayAddToCartConfirmation(JSON.parse(codes));
        sessionStorage.removeItem(AddToCartConfirmationKey);
    }
}

export { displayAddToCartConfirmation, saveAddToCartConfirmation };

// TODO: Is this still in use anywhere?
var displayAddToCartLoginModal = function () {
    var modal = $("#addToCartLoginModal");
    if (modal.length > 0) { // We're only including the modal on the page if we should actually use it
        $("#addToCartLoginModal").modal("show");
        return true;
    } else {
        return false;
    }
};

export { displayAddToCartLoginModal };

var updateMiniCartControl = function (onSuccess) {
    var miniCartControlUrl = $("#mini-cart-dropdown-button").data("url");

    return $.ajax({
        type: "GET",
        cache: false,
        url: miniCartControlUrl,
        success: function (data) {
            $("#mini-cart-dropdown-button").replaceWith(data);
            isFunction(onSuccess) && onSuccess();
        }
    });
};

export const refreshMiniCart = (itemsAddedToCart = 0) => {
    return Promise.all([
        updateMiniCart(undefined, itemsAddedToCart),
        updateMiniCartControl()
    ])
};

var messageNumber = 0;

var makeMessageId = function () {
    return "addToCartMessage" + (++messageNumber);
}

// TODO Move to own module
const BBSMinicartCore = {
    removeFromCart: function (config) {
        var { removeFromCartUrl, onSuccess, onFailure, lineItemGuid } = config;
        fetch(removeFromCartUrl, makeCatalystFetchPostInit({ LineItemGuid: lineItemGuid }))
            .then(resp => resp.json())
            .then(data => {
                if (!data.hasError) {
                    onSuccess(data);
                } else {
                    onFailure();
                }
            })
            .catch((err) => onFailure(err));
    }
};


window.addToCart = function (sku, quantity, url, product, displayConfirmation = true) {
    if (!canAddToCart()) return;
    preventAddToCart();

    return fetch(url, makeCatalystFetchPostInit({ 'SKU': sku, 'qty': quantity, 'returnUrl': '/' }))
        .then(response => response.json())
        .then(data => {
            if (!data.hasError) {
                if (product) {
                    gtm.addToCartOld(quantity, product); // TODO: Remove old GA
                    gtm.addToCart(quantity, product);
                }

                Promise.all([
                    updateMiniCart(undefined, quantity),
                    updateMiniCartControl()
                ])
                    .then(() => {
                        if (displayConfirmation) {
                            displayAddToCartConfirmation();
                        }
                        allowAddToCart();
                    });
            }
            return data;
        })
};

// add to cart functionality
$(document).on("click", ".btn-add-to-cart", function (event) {
    event.preventDefault();
    const thisButton = event.currentTarget;

    if (!canAddToCart()) return;

    try {
        preventAddToCart()
        var addToCartWrapper = $(this).closest(".add-to-cart-wrapper");
        var addToCartParent = $(this).closest(".add-to-cart-parent");
        var recommendationId = $(this).closest(".recommendation-wrapper").data('recommendation-id') || null;
        var code = $(addToCartWrapper).data("code");
        var quantityInputs = $(addToCartWrapper).find(".quantity-wrapper input");
        var quantity = quantityInputs.length ? quantityInputs[0].value : 1;
        quantity = Number.isInteger(+quantity) ? quantity : 1;
        var url = $(addToCartWrapper).data("url");
        const products = window.gtmProducts
            ? window.gtmProducts.filter(product => product.id == code || product.Id == code)
            : [];

        const $addToCartParent = $(addToCartParent);
        $addToCartParent.find(".add-to-cart-error").addClass("hidden");
        fetch(url, makeCatalystFetchPostInit({ code: code, quantity: quantity, recommendationId: recommendationId }))
            .then(resp => resp.json())
            .then(data => {
                if (!data.hasError) {
                    Promise.all([
                        updateMiniCart(undefined, quantity),
                        updateMiniCartControl()
                    ])
                        .then(() => {
                            displayAddToCartConfirmation();
                            allowAddToCart();
                        });

                    if (products.length > 0) {
                        gtm.addToCartOld(quantity, products[0]); // TODO: Remove old GA
                        gtm.addToCart(quantity, products[0]);
                    }
                    var $imageContainer = $('.item-image', addToCartParent);
                    const messageId = makeMessageId();
                    var noteDiv = '<div id="' + (messageId) + '" class="alert alert-default fade show" role="alert">' +
                        'Added to cart<span class="js-add-to-cart-icon"><i class="fa fa-shopping-cart" aria-hidden="true"></i></span>' + '</div>';
                    $imageContainer.append(noteDiv);
                    $addToCartParent.find(".add-to-cart-notification").append(noteDiv);
                    $addToCartParent.find('.add-to-cart-link').blur();
                    setTimeout(function () {
                        $('#' + messageId).remove();
                    }, 2000);
                } else {
                    var $errorWrapper = $addToCartParent.find(".add-to-cart-notification");
                    const unable = "There was an error adding to your cart.";
                    const unableWithMessage = unable + " Message: ";
                    const errorText = data.errorMessage && data.errorMessage.length && data.errorMessage.length > 0 ? unableWithMessage + data.errorMessage : unable;

                    var errorDiv = '<div id="' + makeMessageId() + '"class="alert alert-danger alert-dismissable fade show" role="alert">' +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                        errorText +
                        '</div>';
                    $errorWrapper.append(errorDiv);
                }
            })
            .catch(() => {
                location.reload()
            });
    } catch (e) {
        location.reload();
    }
});

// TODO: Is this still accurate and useful?
const canAddToCart = function () {
    if (displayAddToCartLoginModal()) return false;

    let addToCartButtonsWithConfirmation = $(".js-btn-add-to-cart-confirm");

    return !addToCartButtonsWithConfirmation.hasClass("unclickable");
}

const preventAddToCart = function () {
    let addToCartButtonsWithConfirmation = $(".js-btn-add-to-cart-confirm");
    addToCartButtonsWithConfirmation.addClass("unclickable");
}

const allowAddToCart = function () {
    let addToCartButtonsWithConfirmation = $(".js-btn-add-to-cart-confirm");
    addToCartButtonsWithConfirmation.removeClass("unclickable");
}

$(document).on("keypress",
    ".add-to-cart-parent .qty-option",
    function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            if ($(window).width() >= 992 && !invalid) {
                $(event.currentTarget).siblings(".btn-add-to-cart").trigger("click");
            } else {
                $(':focus').blur();
            }
        }
    }
);

const updateAddToCartDisable = function ($input) {
    const min = $input.prop("min");
    const minInt = parseInt(min);
    const step = $input.prop("step");
    const stepInt = parseInt(step);
    const value = $input.val();
    const valueInt = parseInt(value);
    const invalid = isNaN(valueInt) || (min && (isNaN(minInt) || minInt > valueInt)) || (step && (isNaN(stepInt) || valueInt % stepInt != 0));
    if (!invalid) {
        $input.siblings(".btn-add-to-cart").removeAttr("disabled");
    } else {
        $input.siblings(".btn-add-to-cart").attr("disabled", true);
    }
}

const updateMinicartLoginLinks = function () {
    const baseLoginUrl = new URL($miniCart().data("loginPageUrl"), window.origin);
    const returnUrl = new URL(window.location);
    returnUrl.searchParams.set("minicart", true);
    $('.js-minicart-login-link').attr('href', baseLoginUrl + "?ReturnUrl=" + encodeURIComponent(returnUrl.pathname + returnUrl.search));
}

const updateCartPageLoginLinks = function () {

    $("a.js-cartpage-login-link").on("click", function () {
            gtm.addtoDataLayerLoginClick('cart');
    });
}

$(document).on("keyup",
    ".add-to-cart-parent .qty-option",
    function () {
        updateAddToCartDisable($(this));
    }
);

$(document).on("change",
    ".add-to-cart-parent .qty-option",
    function () {
        updateAddToCartDisable($(this));
    }
);

$(document).on("input change paste",
    ".add-to-cart-parent input.qty-option, .add-to-cart-parent input.featured-product__count",
    function filterNumericAndDecimal(event) {
        removeDotFromNumber($(event.target));
    }
);

$(document).on("change",
    ".featured-product-with-variations__actions input.featured-product-with-variations__count",
    function filterNumericAndDecimal(event) {
        removeDotFromNumber($(event.target));
    }
);

const removeDotFromNumber = function ($qtyBox) {
    var newval = Math.trunc($qtyBox.val())
    if (newval == 0) {
        newval = '';
    }
    $qtyBox.val(newval);
}

var gtmGetProductByCode = function (code) {
    const products = window.gtmCartProducts
        ? window.gtmCartProducts.filter(p => p.id == code)
        : [];
    return products.length > 0
        ? products[0]
        : null;
}

var gtmRemoveProductFromShoppingCart = function (code, quantity) {
    const product = gtmGetProductByCode(code);
    if (product) {
        gtm.removeFromShoppingCart(quantity, product);
    }
}

var gtmIncrementProductFromShoppingCart = function (code, quantity) {
    const product = gtmGetProductByCode(code);
    if (product) {
        gtm.addToCartOld(quantity, product); // TODO: Remove old GA
        gtm.addToCart(quantity, product);
    }
}

var gtmProductClick = function (code, list, position) {
    const product = gtmGetProductByCode(code);
    if (product) {
        gtm.productClick(product, list, position);
    }
}


// Minicart - confirmed used
$(document).on("click", "#miniCart .cart-item-delete:not(:disabled)", function (e) {
    e.preventDefault();
    var code = $(e.currentTarget).closest(".minicart__list-item").data("line-item-code");
    var lineItemGuid = $(e.currentTarget).closest(".minicart__list-item").data("line-item-guid");
    var quantity = $(e.currentTarget).closest(".minicart__list-item").data("line-item-quantity");
    var deleteUrl = $miniCart().data("urlRemoveFromCart");
    var onSuccess = function () {
        gtmRemoveProductFromShoppingCart(code, quantity);
        updateMiniCart();
        updateMiniCartControl();
    };
    var onFailure = function () {
        window.alert("Could not delete.");
    };
    if (window.confirm("Delete this item from your cart?")) {
        $miniCart().dropdown('hide');
        BBSMinicartCore.removeFromCart({
            lineItemGuid,
            removeFromCartUrl: deleteUrl,
            onSuccess,
            onFailure
        });
    }
});

$(document).on("click", "#miniCart .minicart-product a", function (e) {
    var code = $(e.currentTarget).closest(".minicart__list-item").data("line-item-code");
    gtmProductClick(code, 'MiniCart');
});

$(document).on("click", "#miniCart a.js-minicart-login-link", function (e) {
    gtm.addtoDataLayerLoginClick('minicart');
});

(function ($) {
    $(document).ready(function () {

        // Shopping Cart Page
        const shoppingCartItemsWrapperSelector = '.js-shopping-cart-page-items';
        const updateCartUrl = $(shoppingCartItemsWrapperSelector).data("updateCartUrl");
        const removeFromCartUrl = $(shoppingCartItemsWrapperSelector).data("removeFromCartUrl");

        if ($(shoppingCartItemsWrapperSelector).length > 0) {
            displaySavedAddToCartConfirmation();
        }

        const windowSearchParams = new URLSearchParams(window.location.search);
        if (!!windowSearchParams.get('minicart')) {
            showMiniCart();
            let newUrl = new URL(window.location);
            newUrl.searchParams.delete('minicart');
            newUrl = newUrl.toString();
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
        updateMinicartLoginLinks();
        updateCartPageLoginLinks();
        $(".minicart__dropdown-wrapper").on('show.bs.dropdown', function () {
            updateMinicartLoginLinks();
        });
        $(".minicart__dropdown-wrapper").on('hidden.bs.dropdown', function () {
            $miniCart().find('.minicart__items-added').remove();
        });

        const atc_code = windowSearchParams.get('atc_code');
        let atc_qty = windowSearchParams.get('atc_qty');
        let atc_recid = windowSearchParams.get('atc_recid');
        if (!atc_qty) atc_qty = 1;
        if (!!atc_code) {
            const minicartWrapper = $('.js-minicart-wrapper');
            if (minicartWrapper.length) {
                const addToCartUrl = minicartWrapper.data('addToCartUrl');
                //window.addToCart(atc_code, atc_qty, addToCartUrl, null);

                fetch(addToCartUrl, makeCatalystFetchPostInit({ code: atc_code, quantity: atc_qty, recommendationId: atc_recid }))
                    .then(resp => resp.json())
                    .then(data => {
                        if (!data.hasError) {
                            Promise.all([
                                updateMiniCart(undefined, atc_qty),
                                updateMiniCartControl()
                            ])
                                .then(() => {
                                    displayAddToCartConfirmation();
                                    allowAddToCart();
                                });

                            // TODO: Is it possible to get gtm info here?
                            //if (products.length > 0) {
                            //    gtm.addToCartOld(quantity, products[0]); // TODO: Remove old GA
                            //    gtm.addToCart(quantity, products[0]);
                            //}
                        } else {
                            // How do we handle errors?
                        }
                    });
            }
            let newUrl = new URL(window.location);
            newUrl.searchParams.delete('atc_code');
            newUrl.searchParams.delete('atc_qty');
            newUrl.searchParams.delete('atc_reccid');
            newUrl = newUrl.toString();
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }

        const updateCart = function (lineItemGuid, code, qty, originalQuantity) {
            fetch(updateCartUrl, makeCatalystFetchPostInit({ LineItemGuid: lineItemGuid, qty: qty }))
                .then(resp => resp.json())
                .then((data) => {
                    if (!data.hasErrors) {
                        if (originalQuantity < qty)
                            gtmIncrementProductFromShoppingCart(code, qty - originalQuantity);
                        else
                            gtmRemoveProductFromShoppingCart(code, originalQuantity - qty);
                        window.location.reload(true);
                    }
                });
        };

        const removeFromCart = function (lineItemGuid, code, quantity) {
            fetch(removeFromCartUrl, makeCatalystFetchPostInit({ LineItemGuid: lineItemGuid }))
                .then(resp => resp.json())
                .then((data) => {
                    if (!data.hasErrors) {
                        gtmRemoveProductFromShoppingCart(code, quantity);
                        window.location.reload(true);
                    }
                });
        };

        const displayLoadingIcon = function () {
            $(".shopping-cart-page > .loading").css('display', 'flex');
        }

        // Shopping Cart Page - Click
        $(document).on("click", `${shoppingCartItemsWrapperSelector} a`, function () {
            const $cartItem = $(this).closest(".js-shopping-cart-item");
            const code = $cartItem.data("lineItemCode");
            gtmProductClick(code, 'ShoppingCart');
        });

        // Shopping Cart Page - Update quantity
        $(document).on("change", `${shoppingCartItemsWrapperSelector} .js-update-qty:not(:disabled)`, function () {
            const min = $(this).prop('min');
            const step = $(this).prop('step');
            const minInt = parseInt(min);
            const stepInt = parseInt(step);
            const valueInt = parseInt(event.target.value);
            const caseErrorMsg = $(this).siblings('.qty-case-error-msg');
            const invalid = isNaN(valueInt) || (min && (isNaN(minInt) || minInt > valueInt)) || (step && (isNaN(stepInt) || valueInt % stepInt != 0));
            if (invalid) {
                //var message = $(this).data("qtyMessage");
                //$(this).attr("title", message);
                caseErrorMsg && caseErrorMsg.removeClass('d-none');
                return false;
            }
            else {
                caseErrorMsg && caseErrorMsg.addClass('d-none');
            }
            //else $(this).attr("title", "");
            displayLoadingIcon();
            const $cartItem = $(this).closest(".js-shopping-cart-item");
            const code = $cartItem.data("lineItemCode");
            const lineItemGuid = $cartItem.data("lineItemGuid");
            const qty = $(this).val();
            const originalQuantity = $cartItem.data("lineItemQuantity");
            updateCart(lineItemGuid, code, qty, originalQuantity);
        });

        // Shopping Cart Page - Remove From Cart
        $(document).on("click", `${shoppingCartItemsWrapperSelector} .cart-item-delete:not(:disabled)`, function () {
            displayLoadingIcon();
            const $cartItem = $(this).closest(".js-shopping-cart-item");
            const code = $cartItem.data("lineItemCode");
            const lineItemGuid = $cartItem.data("lineItemGuid");
            const quantity = $cartItem.data("lineItemQuantity");
            removeFromCart(lineItemGuid, code, quantity);
        });
    });
})($, BBSMinicartCore);